module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IWD02U/tc-custom/9781401689629.jpg?1721404537957",
      "alt": "This image is the cover for the book Motherless"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Motherless\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A WHISPERING VOICE "), _c('i', [_vm._v("at the ")]), _vm._v("BACK "), _c('i', [_vm._v("of ")]), _vm._v("MY MIND REMINDS ME "), _c('i', [_vm._v("that ")]), _vm._v("I’VE BEEN THIS WAY "), _c('i', [_vm._v("for ")]), _vm._v("SOME TIME.")])]), _c('p', [_c('b', [_vm._v("DEAD, THAT IS.")])]), _c('p', [_vm._v("The dead have a very broad view of the living, of actions performed out of sight, of thoughts believed to be private. I would know. Losing both parents is a trial no child should endure, and Marina and Dylan have endured enough. They deserve the one thing I could never give them: a mother’s love.")]), _c('p', [_vm._v("A mother’s love, and the truth.")]), _c('p', [_vm._v("My children have believed a lie about me for years and years. After all this time I can still feel their hurt in my heart. But the tether holding me to them is frayed from years of neglect . . . and I have to find a way to make my confession before it snaps.")]), _c('p', [_vm._v("But when the truth comes out, what other beasts will I unleash?")]), _c('p', [_vm._v("“Why do we lie to the children?” someone asked me once.")]), _c('p', [_vm._v("“To protect them,” I answered.")]), _c('p', [_vm._v("How terrible it is that they need protection from me.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Erin Healy\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0